import { makeStyles } from 'tss-react/mui';

export const navBarWidth = 56;
export const navBarWidthOpen = 190;
export const navBarDiff = navBarWidth - navBarWidthOpen;
export const dividerSpacing = '8px';

export const useNavBarStyle = makeStyles<void, 'groupDivider'>()((theme, _, classes) => ({
  navbarClosed: {
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.palette.background.paper,
    width: navBarWidth,
    left: 0,
    height: '100%',
    overflow: 'hidden',
    transition: 'width .25s ease',
    transitionDelay: '300ms',
    boxShadow: theme.shadows[24],
  },
  navbar: {
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.palette.background.paper,
    width: navBarWidthOpen,
    left: 0,
    height: '100%',
    overflow: 'hidden',
    transition: 'width .25s ease',
    transitionDelay: '300ms',
    boxShadow: theme.shadows[24],
    [`.${classes.groupDivider}`]: {
      display: 'flex',
    },
  },
  group: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  groupDivider: {
    display: 'flex',
    backgroundColor: theme.palette.border.light,
    height: '1px',
    marginTop: dividerSpacing,
    marginBottom: dividerSpacing,
    width: '100%',
  },
  groupDividerStatic: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    display: 'flex',
    backgroundColor: theme.palette.border.light,
    height: '1px',
    marginTop: dividerSpacing,
    marginBottom: dividerSpacing,
    width: 'inherit',
  },
}));

const useStylesInternal = makeStyles()((theme) => {
  const itemVerticalSpacing = 6;
  const iconMargin = 6;
  return {
    navMenuItem: {
      color: theme.palette.icon.main,
      opacity: 1,
      justifyContent: 'unset',
      whiteSpace: 'nowrap',
      display: 'flex',
      flexDirection: 'row',
      textTransform: 'none',
      alignItems: 'center',
      textAlign: 'center',
      outline: 'none',
      padding: `${itemVerticalSpacing}px 0px ${itemVerticalSpacing}px 12px`,
      width: navBarWidthOpen,
      '&:hover': {
        opacity: 1,
        color: `${theme.palette.primary.main} !important`,
        background: `${theme.palette.action.hover} !important`,
        cursor: 'pointer',
      },
      '&:focus': {
        opacity: 1,
        color: theme.palette.primary.main,
        background: theme.palette.action.hover,
      },
      transition: 'all 200ms cubic-bezier(0.550, 0.085, 0.680, 0.530)',
    },
    navMenuItemSupport: {
      color: theme.palette.icon.main,
      opacity: 1,
      justifyContent: 'unset',
      whiteSpace: 'nowrap',
      display: 'flex',
      flexDirection: 'row',
      textTransform: 'none',
      alignItems: 'center',
      textAlign: 'center',
      outline: 'none',
      padding: `${itemVerticalSpacing}px 32px ${itemVerticalSpacing}px 12px`,
      width: navBarWidthOpen,
      '&:hover': {
        opacity: 1,
        color: `${theme.palette.primary.main} !important`,
        background: `${theme.palette.action.hover} !important`,
        cursor: 'pointer',
      },
      transition: 'all 200ms cubic-bezier(0.550, 0.085, 0.680, 0.530)',
      '&:focus': {
        background: 'inherit',
        color: theme.palette.icon.main,
      },
    },
    selectedItem: {
      color: `${theme.palette.primary.main} !important`,
      background: `${theme.palette.action.hover} !important`,
      '&:hover': {
        opacity: 1,
        color: `${theme.palette.primary.main} !important`,
        background: `${theme.palette.action.hover} !important`,
        cursor: 'pointer',
      },
    },
    selectedNavText: {
      color: theme.palette.primary.main,
      marginLeft: 16,
      textAlign: 'left',
    },
    navText: {
      color: theme.palette.text.primary,
      marginLeft: 16,
      textAlign: 'left',
    },
    navBarIconSpan: {
      display: 'flex',
      height: 20,
      alignItems: 'center',
      justifyContent: 'center',
    },
    navIcon: {
      width: 20,
      height: 20,
      fill: '',
      marginLeft: iconMargin,
      marginRight: iconMargin,
    },
    navIconNoMargin: {
      width: 20,
      height: 20,
      stroke: 'currentColor',
    },
    navIconParentMargin: {
      marginLeft: iconMargin,
      marginRight: iconMargin,
    },
  };
});

export const useNavItemStyles = () => {
  return useStylesInternal();
};
